import type { SxProps, Theme } from '@mui/material/styles'

const contentAreaBaseSx = {
  flex: 1,
  minWidth: 0,
  width: '100%',
  boxSizing: 'border-box',
  p: '32px 40px 80px',
} as const

/** Padding and width of the main content column in SettingsLayout. */
export const settingsContentAreaSx: SxProps<Theme> = contentAreaBaseSx

/** Same padding as settings pages, without max-width (no settings sidebar). */
export const dashboardContentAreaSx: SxProps<Theme> = contentAreaBaseSx
